import { useMemo } from "react";

import { getFullName } from "@vega-api/custom/utils/user";
import {
  addSelectItemFieldsToUser,
  type SearchMultiSelectItemWithUser,
} from "@vega-core/components/Form/Controls/Input/SearchUser/SearchUserMultiselect";

import { useGpUsersForDealSearch } from "./useGpUsersForDealSearch";

type UseSenderSearchParams = {
  dealId: string;
  /** When set (e.g. first prospect's relationship), included at top of results if not already in list */
  selectedItemToInclude?: SearchMultiSelectItemWithUser | null;
};

export const useSenderSearch = ({
  dealId,
  selectedItemToInclude,
}: UseSenderSearchParams) => {
  const {
    searchValue,
    setSearchValue,
    data: searchGpUsersData,
    isPending,
  } = useGpUsersForDealSearch({ dealId });

  const gpUsersSearchItems = useMemo(() => {
    const items = searchGpUsersData.map((user) =>
      addSelectItemFieldsToUser({
        id: user.id,
        fullName: getFullName(user.fullName),
        email: user.email,
      }),
    );

    if (
      selectedItemToInclude &&
      !items.some((u) => u.id === selectedItemToInclude.id)
    ) {
      items.unshift(selectedItemToInclude);
    }

    return items;
  }, [searchGpUsersData, selectedItemToInclude]);

  return {
    senderSearchValue: searchValue,
    onSenderSearchChange: setSearchValue,
    gpUsersSearchItems,
    isSenderSearchLoading: isPending,
  };
};
